module.exports = __webpack_public_path__ + "img/card0.83da3993.png";